import t from "../../../helpers/t";
import {_, moment} from "../../../../../vendor";
import {Biscuit} from "../../../../utils";
import React, {useState} from "react";
import DatePicker from "react-datepicker";
import ResourcesView from "./ResourcesView";

const CheckOutItem = (props) => {
    const [commentCheckin, setCommentCheckin] = useState(null);
    const [commentCheckout, setCommentCheckout] = useState(null);
    const contingent = props.contingent;
    const isStepCheckout = props.isStepCheckout;
    const selectionIsComplete = props.selectionIsComplete;
    const isCartView = true;
    const resources = props.resources;
    const checkoutComplete = props.checkoutComplete;
    const locationsPending = props.locationsPending;
    const locations = props.locations;
    const locationCheckout = props.locationCheckout;
    const setTableCSS = props.setTableCSS;
    const date = (typeof props.checkin.checkout !== 'undefined' && props.checkin.checkout !== null && checkoutComplete?props.checkin.checkout:props.date);
    let checkoutCompleteClass = checkoutComplete === true ? "hide" : "";
    let bikeSharingHideClass = (Biscuit.get('client.isBikeSharing') === 'true' || Biscuit.get('client.isVehicleOwner') === 'true' || Biscuit.get('client.hasParkingLots') === 'true') && isStepCheckout ? '' : ' hide';
    const onDatePickerChangeHandle = (dates) => {
        props._changeCheckoutDate(dates);
    };
    props.setForCheckoutExtended(false);
    const onItemClickHandler = (resource) => {
        if(typeof props._checkin.selectedResources[resource.id] !== 'undefined'){
            let clone = {...props._checkin};
            delete clone.selectedResources[resource.id];
            props._setCheckin(clone);
        }
    }

    return (
        <>
            {Object.keys(props._checkin.selectedResources).length === 0 && <>
                <div className="inb-c-item inb-c-item--contingent inb-c-item--checkinout row toggled" style={{borderImage: "linear-gradient(to left, #f9f9fc 65%, #f9f9fc) 1 100%"}}>
                    {!isStepCheckout &&
                    <>
                        <div id="inb-checkin-empty-list" className="text-center" style={{width: "100%"}}>
                            <p>&nbsp;</p>
                            <img src="/assets/img/select_list.svg" style={{maxWidth: '280px'}} alt=""/>
                            <p>&nbsp;</p><p>&nbsp;</p>
                            <p style={{fontSize: "1.2rem"}}>{t('checkin_add_elements_to_cart')}</p>
                        </div>
                    </>
                    }
                </div>
            </>
            }
            {Object.keys(props._checkin.selectedResources).length !== 0 && <>
                <div className="inb-c-item inb-c-item--contingent inb-c-item--checkinout row toggled"  style={{borderImage: "linear-gradient(to left, #f9f9fc 65%, #f9f9fc) 1 100%"}}>
                    <div className="medium-4 small-6 column inb-contingent__name inb-order-big" style={{whiteSpace:"nowrap"}}>
                        {contingent.name}
                    </div>

                    <div className="medium-5 small-12 medium-offset-0 column inb-contingent__description">
                        {contingent.description}
                    </div>

                    <div className="medium-3 column inb-contingent__sys_status text-right">
                        {!isStepCheckout &&
                        <>
                            {selectionIsComplete &&
                            <>
                                <div className="button round success hollow smart-resource-select"
                                     title={t('checkin_selection_complete')}>
                                    <i className="fi fi-check" style={{paddingRight: "0"}}> </i>
                                </div>
                            </>
                            }
                        </>
                        }
                    </div>

                    {Object.keys(props._checkin.selectedResources).length !== 0 &&
                    <>
                        <div id={"resources-panel-" + contingent.id}
                             className="inb-c-item-details inb-c-contingent-resources row">
                            <header className="inb-c-item-details__header small-12 column">
                <span className="inb-list-title">
                {!isStepCheckout ? t('checkin_resources_total') + ": " + props._checkin.total + " |" + t('checkin_resources_selected') + ": " + _.size(props._checkin.selectedResources):''}
                </span>
                                {!isStepCheckout &&
                                <>
                                    {resources.length === 0 &&
                                    <>
                            <span className="inb-list-title float-right" style={{color: "red"}}>
                                {t('available') + ": " + resources.length}
                            </span>
                                    </>
                                    }
                                    {resources.length > 0 &&
                                    <>
                            <span className="inb-list-title float-right">
                             {t('available') + ": " + resources.length}
                            </span>
                                    </>
                                    }
                                </>
                                }
                            </header>




                            <ResourcesView
                                _checkin={props._checkin}
                                isCartView={isCartView}
                                resources={resources}
                                isStepCheckout={isStepCheckout}
                                location_checkin={props.location_checkin}
                                selectedResources={props.selectedResources}
                                location_checkout={props.location_checkout}
                                onItemClickHandler={onItemClickHandler}
                                _changeCommentCheckIn={props._changeCommentCheckIn}
                                _changeCommentCheckOut={props._changeCommentCheckOut}
                            />
                        </div>

                        <div className="inb-contingent-progress"> </div>

                        <div
                            className={"inb-c-item row right inb-c-item--checkinout" + bikeSharingHideClass}
                            style={{width: "100%", paddingRight: "0"}}>
                            <div className="medium-12 small-12 column"
                                 style={{display: "table", minHeight: "40px", paddingBottom: "5px"}}>
                                <span style={{display: "table-cell"}}>{t('manual_checkout_heading')}</span>
                            </div>
                            <div className="medium-2 small-12 column" style={{
                                fontWeight: "bold",
                                display: "table",
                                minHeight: "50px",
                                paddingTop: "5px",
                                paddingBottom: "5px"
                            }}>
                                        <span style={{
                                            display: "table-cell",
                                            verticalAlign: "middle"
                                        }}>{t('location_')}:</span>
                            </div>
                            <div className="medium-4 small-12 column" style={{paddingTop: "10px"}}>
                    <span id="inb-checkout-location-alert" className="hide"
                          style={{display: "inline-block", transform: "translateY(2px)", color: "red"}}
                          title={t('no_location_selected') + ' ' + t('select_checkout_location_info')}>
                        <i className="fi fi-alert"> </i>
                    </span>
                                {!checkoutComplete && <><select id="inb-checkout-location"
                                                                title={t('select_checkout_location_info')}
                                                                placeholder="test"
                                                                onChange={(e)=>{props.changeLocation(e)}}
                                                                style={{
                                                                    width: "calc(100% - 20px)",
                                                                    marginBottom: "0"
                                                                }}
                                >
                                    {!locationsPending && locations.map(location => {
                                        return (
                                            <>
                                                {locationCheckout === location.id &&
                                                <option value={location.id} selected>{location.name}</option>
                                                }
                                                {locationCheckout !== location.id &&
                                                <option value={location.id}>{location.name}</option>
                                                }
                                            </>
                                        )
                                    })}
                                </select></>}
                                {checkoutComplete && <><select id="inb-checkout-location"
                                                               title={t('select_checkout_location_info')}
                                                               placeholder="test"
                                                               style={{
                                                                   width: "calc(100% - 20px)",
                                                                   marginBottom: "0"
                                                               }}
                                                               disabled>
                                    {!locationsPending && locations.map(location => {
                                        return (
                                            <>
                                                {locationCheckout === location.id &&
                                                <option value={location.id} selected>{location.name}</option>
                                                }
                                                {locationCheckout !== location.id &&
                                                <option value={location.id}>{location.name}</option>
                                                }
                                            </>
                                        )
                                    })}
                                </select></>}
                            </div>
                            <div className="medium-5 show-for-large-only column" style={setTableCSS}>
                            </div>

                            <div className="medium-2 small-12 column" style={setTableCSS}>
                                        <span
                                            style={{display: "table-cell", verticalAlign: "middle"}}>{t('date')}:</span>
                            </div>

                            <div className="medium-4 small-12 column" style={{paddingTop: "10px"}}>
                    <span id="inb-checkout-date-alert" className="hide"
                          style={{display: "inline-block", transform: "translateY(2px)", color: "red"}}
                          title={t('no_location_selected') + ' ' + t('select_checkout_location_info')}>
                        <i className="fi fi-alert"> </i>
                    </span>
                                {!checkoutComplete &&
                                <>
                                    <DatePicker
                                        key={"inb-checkinout-date-" + Math.floor(Math.random() * 10000)}
                                        className="datepicker-date form-control"
                                        dateFormat="dd.MM.y"
                                        selected={date}
                                        onChange={dates => onDatePickerChangeHandle(dates)}
                                        onKeyDown={e => {
                                            if (e.keyCode === 8) e.preventDefault();
                                        }}
                                    /></>}
                                {/*<a className={picker.selected === null ? "react-datepicker-close hide" : "react-datepicker-close"} name={picker.name} onClick={(e) => {onDatePickerCloseHandle(e,picker.name)}}>x</a>



                            <input type="text" className="datepicker-date form-control "
                                   autoComplete="off"
                                   name="checkout-date" maxLength="255" placeholder=""
                                   aria-label="Use the arrow keys to pick a date"
                                   value={date.format('D. MMMM YYYY')}
                                   onChange={() => props.getCheckoutPrice}/>*/}

                                {checkoutComplete &&
                                <>
                                    <input type="text" className="datepicker-date form-control "
                                           autoComplete="off"
                                           name="checkout-date" maxLength="255" placeholder=""
                                           aria-label="Use the arrow keys to pick a date"
                                           value={moment(date).format('D. MMMM YYYY')} disabled/>
                                </>}
                            </div>

                            <div className="medium-5 show-for-large-only column" style={setTableCSS}>

                            </div>

                            <div className="medium-2 small-12 column" style={{setTableCSS}}>
                    <span style={{display: "table-cell", verticalAlign: "middle"}}>
                        {t('time')}:
                    </span>
                            </div>

                            <div className="medium-4 small-12 column" style={{paddingTop: "10px"}}>
                    <span id="inb-checkout-time-alert" className="hide"
                          style={{display: "inline-block", transform: "translateY(2px)", color: "red"}}
                          title={t('no_location_selected') + ' ' + t('select_checkout_location_info')}>
                        <i className="fi fi-alert"> </i>
                    </span>
                                {!checkoutComplete &&
                                <>
                                    <input id="inb-checkout-time" type="time" className="form-control"
                                           autoComplete="off"
                                           name="checkout-time" maxLength="255" placeholder=""
                                           value={moment(date).format('HH:mm')}
                                           onChange={ev=> props._changeCheckoutTime(ev)}/>
                                </>
                                }
                                {checkoutComplete &&
                                <>
                                    <input id="inb-checkout-time" type="text" className="form-control"
                                           autoComplete="off"
                                           name="checkout-time" maxLength="255" placeholder=""
                                           value={moment(date).format('HH:mm')} disabled/>
                                </>
                                }
                            </div>

                            <div className="medium-5 show-for-large-only column" style={setTableCSS}>
                            </div>

                            <div className="hide">
                                <input id="inb-hidden-checkout-date"
                                       value={moment(date).format('YYYY-MM-DD HH:mm:00')}/>
                            </div>
                            <div
                                className={"medium-8 small-12 column " + checkoutCompleteClass}
                                style={{display: "none", paddingTop: "10px", height: "48px"}}>
                            </div>

                            <div className="medium-2 small-12 column">
                            </div>

                            <div
                                className={"medium-4 small-12column " + checkoutCompleteClass}
                                style={{paddingTop: "10px", height: "68px"}}>
                                {!props.checkinPending &&
                                    <button id="submit-order-checkout"
                                            className={"small button beautify beautify-" + Biscuit.get('user.client_id') + " secondary order-button"}
                                            title="" style={{display: "block"}} onClick={props.submitCheckins}>
                                        {t('submit_single_checkout', null, 'capital')}
                                    </button>
                                }
                                {props.checkinPending &&
                                    <span><img alt="RollingLoader" className="rollingLoader colorize-black" src={"assets/img/rolling_loader.svg"} />
                                        {t('submit_single_checkout', null, 'capital')}
                                </span>
                                }
                            </div>

                            <div
                                className={"medium-12 small-12 column " + checkoutCompleteClass}>
                    <span id="inb-checkout-time-alert" style={{color: "red"}} title="">
                        <i className="fi fi-alert"> </i>
                        {t('manual_checkout_hint')}
                    </span>
                                <a id="inb-checkout-cancel-link" href="#"
                                   style={{textDecoration: "underline", paddingLeft:"5px"}} onClick={() =>  props._cancelOrder()}>{t('cancel')}</a>
                            </div>

                            <div
                                className={"medium-4 small-12 column " + checkoutCompleteClass}
                                style={{paddingTop: "10px", display: "none"}}>
                                <button id="submit-order-cancel"
                                        className="small button beautify secondary order-button"
                                        onClick={() => props._cancelOrder()}
                                        title="" style={{display: "block", width: "100%"}}>
                                    {t('cancel', null, 'capital')}
                                </button>
                            </div>
                        </div>
                    </>
                    }
                </div>
            </>}

        </>
    );
}

export default CheckOutItem;